export const initialState = {
  apiStatus: {
    loader: false,
    message: null,
    next: false,
    data: [],
    apiError: false,
    apiSuccess: false,
  },
};
